import Vue from 'vue'
import SliderComponent from 'vue-range-component'

Vue.component('vue-slider', SliderComponent)
